export default {"src":"/_next/static/media/AUD.b7f1c17d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};